import { allRoutes } from "../routes/allRoutes";
import dashboardIcon from "../images/icons/dashboardIcon.svg";
import employeesIcon from "../images/icons/employeesIcon.svg";
import designationIcon from "../images/icons/designationIcon.svg";
import departmentsIcon from "../images/icons/departmentsIcon.svg";
import securityIcon from "../images/icons/securityIcon.svg";
import rolesIcon from "../images/icons/rolesIcon.svg";
import branchesIcon from "../images/icons/branches.svg";
import auditTrailIcon from "../images/icons/auditTrail.svg";
import dashboardIconActive from "../images/icons/activeDashBoard.svg";
import employeesIconActive from "../images/icons/activeUser.svg";
import designationIconActive from "../images/icons/activeDesignation.svg";
import departmentsIconActive from "../images/icons/activeDepartment.svg";
import securityIconActive from "../images/icons/activeSecurity.svg";
import rolesIconActive from "../images/icons/activeRoles.svg";
import branchesIconActive from "../images/icons/activeRoles.svg";
import auditTrailIconActive from "../images/icons/activeAudit.svg";
import branchesNewIcon from "../images/icons/activeBranch.svg";
import PermissionContextFunctions from "../functions/PermissionContextFunctions";
import Nbranch from "../images/icons/branchh.svg";
import branchesNew from "../images/icons/branchesNew.svg";
import branchesNewActive from "../images/icons/branchesNewActive.svg";
import customAddons from "../images/icons/customAddons.svg";
import customAddonsActive from "../images/icons/customAddonsActive.svg";

const route = allRoutes;

export const SidebarData2 = [
  {
    title: "Main",
    menuList: [
      {
        permissionKey: "Dashboard",
        iconActive: dashboardIconActive,
        icon: dashboardIcon,
        label: "Dashboard",
        link: route.dashboard,
      },
      {
        permissionKey: "Employee",
        iconActive: employeesIconActive,
        icon: employeesIcon,
        label: "Employees",
        link: route.employees,
      },
    ],
  },
  {
    title: "Master",
    menuList: [
      {
        permissionKey: "Designation",
        iconActive: designationIconActive,
        icon: designationIcon,
        label: "Designations",
        link: route.designations,
      },
      {
        permissionKey: "Department",
        iconActive: departmentsIconActive,
        icon: departmentsIcon,
        label: "Departments",
        link: route.departments,
      },
      {
        permissionKey: "SecurityGroup",
        iconActive: securityIconActive,
        icon: securityIcon,
        label: "Security Groups",
        link: route.securityGroups,
      },
      {
        permissionKey: "Role",
        iconActive: rolesIconActive,
        icon: rolesIcon,
        label: "Roles",
        link: route.roles,
      },
      {
        permissionKey: "Branch",
        iconActive: branchesNewActive,
        icon: branchesNew,
        label: "Branches",
        link: route.branches,
      },
      {
        permissionKey: "Employee",
        iconActive: customAddonsActive,
        icon: customAddons,
        label: "Custom Addons",
        link: route.customAddon,
      },
    ],
  },
  {
    title: "Audit Trail",
    menuList: [
      {
        permissionKey: "AuditTrial",
        iconActive: auditTrailIconActive,
        icon: auditTrailIcon,
        label: "Audit Trails",
        link: route.auditTrail,
      },
    ],
  },
];

export const SidebarData = [
  {
    label: "Dashboard",
    link: route.dashboard,
  },
  {
    label: "Employees",
    link: route.employees,
  },
  {
    label: "Designations",
    link: route.designations,
  },
  {
    label: "Departments",
    link: route.departments,
  },
  {
    label: "Security Groups",
    link: route.securityGroups,
  },
  {
    label: "Roles",
    link: route.reports,
  },
  {
    label: "Branches",
    link: route.branches,
  },
  {
    label: "Audit Trials",
    link: route.auditTrail,
  },
  {
    label: "Employee Profile",
    link: route.employeeProfile,
  },
];
